module.exports = __webpack_public_path__ + "img/patent_image3.e418b646.png";